import { useId, type ReactNode } from 'react'

import { SurfaceCard } from './SurfaceCard'

export const SettingsSection = ({
    title,
    description,
    children,
}: {
    title: string
    description?: string
    children: ReactNode
}) => {
    const titleId = useId()

    return (
        <section aria-labelledby={titleId}>
            <h2 id={titleId} className="text-account-strong mb-3 text-base font-semibold">
                {title}
            </h2>
            {description && <p className="text-account-secondary mb-4 text-sm">{description}</p>}
            <SurfaceCard padded={false}>{children}</SurfaceCard>
        </section>
    )
}
